module.exports = __webpack_public_path__ + "img/CHANGLIAN.7cbcb465.png";